module.exports = __webpack_public_path__ + "img/boleto-barcode.7fca04f4.svg";